'use strict';

const React = require('react');
const PropTypes = require('prop-types');
const {trackDealerLinkClick} = require('../../actions/pdpTrackingActions.es.js');
const GridBase = require('./GridBase');
const GridHeader = require('./GridHeader');
const GridItem = require('./GridItem');

class GridDealer extends GridBase {

    constructor(props) {
        super(props);

        this.state = {
            quickViewItemId: null
        };

        this._setQuickViewId = this._setQuickViewId.bind(this);

        this._handleClick = this._handleClick.bind(this);
    }

    _handleClick() {
        if (this.context.executeAction) {
            this.context.executeAction(trackDealerLinkClick, {location: 'more from dealer module'});
        }
        if (this.props.trackViewAllClick) {
            this.props.trackViewAllClick();
        }
    }

    _getHeader() {
        const {dealerData, copy} = this.props;
        return <GridHeader type={dealerData.type} title={copy.dealer.carouselHeader} />;
    }

    _getItems() {
        return this.props.data.map((data, index) => {
            // index needs to be 1-based, not 0-based
            data.index = index + 1;

            return (
                <div className="pdp-grid-item colLg3 colMd4 colXs6" key={data.id}>
                    <GridItem
                        setQuickViewId={this._setQuickViewId}
                        quickViewItemId={this.state.quickViewItemId}
                        quickView={this.props.quickView}
                        onProductClick={this.props.trackProductClick}
                        {...data}
                    />
                </div>
            );
        });
    }

    _getViewAll() {
        return (
            <div className="pdp-grid-view-all-button">
                <a href={this.props.dealerData.uri}
                    className="button-medium button-secondary"
                    onClick={this._handleClick}
                >
                    View All
                </a>
            </div>
        );
    }
}

GridDealer.propTypes = {
    data: PropTypes.array,
    dealerData: PropTypes.object.isRequired,
    copy: PropTypes.object.isRequired,
    trackViewAllClick: PropTypes.func,
    trackProductClick: PropTypes.func,
    quickView: PropTypes.bool
};

GridDealer.defaultProps = {
    data: [],
    domId: 'dealer-grid',
    quickView: false
};

module.exports = GridDealer;



// WEBPACK FOOTER //
// ./assets/js/newPdp/components/Grid/GridDealer.jsx